import { Injectable } from '@angular/core';
import { DynamicFormControlEvent } from '@ng-dynamic-forms/core';
import isObject from 'lodash/isObject';

import { VocabularyEntry } from '../../../../../../app/core/submission/vocabularies/models/vocabulary-entry.model';
import { isNotEmpty } from '../../../../../../app/shared/empty.util';
import { DsDynamicInputModel } from '../../../../../../app/shared/form/builder/ds-dynamic-form-ui/models/ds-dynamic-input.model';
import { DYNAMIC_FORM_CONTROL_TYPE_TAG } from '../../../../../../app/shared/form/builder/ds-dynamic-form-ui/models/tag/dynamic-tag.model';
import { FormFieldMetadataValueObject } from '../../../../../../app/shared/form/builder/models/form-field-metadata-value.model';
import { SectionFormOperationsService as BaseSectionFormOperationsService } from '../../../../../../app/submission/sections/form/section-form-operations.service';

/**
 * BfS: stores the language code selected in the dropdown of a tag field (e.g. Schlagwörter
 * dc.subject / dc.subject.other) with every tag. The base service only stores the language
 * for single value fields (onebox, textarea), for tag fields the code is lost.
 * All other fields are handled by the base service.
 */
@Injectable()
export class SectionFormOperationsService extends BaseSectionFormOperationsService {

  /**
   * Return the value of the field interesting in the specified change operation
   *
   * @param event
   *    the [[DynamicFormControlEvent]] for the specified operation
   * @return any
   *    the field value
   */
  public getFieldValueFromChangeEvent(event: DynamicFormControlEvent): any {
    const model = event.model as DsDynamicInputModel;
    const value = (event.model as any).value;
    if (model.type === DYNAMIC_FORM_CONTROL_TYPE_TAG && Array.isArray(value) && isNotEmpty(model.language)) {
      return this.getTagValuesWithLanguage(value, model.language);
    }
    return super.getFieldValueFromChangeEvent(event);
  }

  /**
   * Set the language code selected in the dropdown on all values of a tag field
   * (one dropdown per field, so all tags of the field get the same code)
   *
   * @param values
   *    the tag values (strings or objects)
   * @param language
   *    the language code
   * @return any[]
   *    the values with language code
   */
  protected getTagValuesWithLanguage(values: any[], language: string): any[] {
    return values.map((entry) => {
      if (typeof entry === 'string') {
        return new FormFieldMetadataValueObject(entry, language);
      }
      if (!isObject(entry)) {
        return entry;
      }
      if (entry instanceof VocabularyEntry) {
        return Object.assign(new VocabularyEntry(), entry, { language });
      }
      const item = entry as any;
      return new FormFieldMetadataValueObject(item.value, language, item.authority, item.display, item.place,
        item.confidence, item.otherInformation);
    });
  }
}
